import { render, staticRenderFns } from "./estudo-laudo.vue?vue&type=template&id=0232a516&"
import script from "./estudo-laudo.vue?vue&type=script&lang=js&"
export * from "./estudo-laudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports